var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"form-control",attrs:{"placeholder":"Поиск по адресу","data-test-id":"geocoder-input"},on:{"click":function($event){return _vm.geocoderWarn($event)}}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }